import { Link } from "react-router-dom";
import { allArticles } from "@/mocks/articles";

const cardImages: Record<string, string> = {
  "artigo-hoobuy-spreadsheet": "https://readdy.ai/api/search-image?query=Modern%20laptop%20with%20colorful%20spreadsheet%20interface%20on%20screen%20placed%20on%20warm%20wooden%20desk%2C%20surrounded%20by%20fashion%20accessories%20like%20sneakers%20and%20sunglasses%2C%20soft%20natural%20window%20light%2C%20editorial%20photography%2C%20cream%20and%20beige%20tones%2C%20organized%20productive%20workspace%20aesthetic%2C%20clean%20composition&width=800&height=560&seq=seov2-card-w1&orientation=landscape",
  "como-economizar-hoobuy": "https://readdy.ai/api/search-image?query=Stack%20of%20gold%20coins%20next%20to%20premium%20fashion%20sneakers%20and%20leather%20wallet%20on%20warm%20cream%20surface%2C%20piggy%20bank%20in%20soft%20focus%20background%2C%20natural%20window%20light%2C%20editorial%20photography%2C%20beige%20and%20sand%20tones%2C%20money%20saving%20and%20smart%20shopping%20concept%2C%20clean%20composition&width=800&height=560&seq=seov2-card-w2&orientation=landscape",
  "hoobuy-e-seguro": "https://readdy.ai/api/search-image?query=Metallic%20padlock%20beside%20designer%20handbag%20and%20gold%20watch%20on%20warm%20sand%20colored%20surface%2C%20security%20shield%20icon%20reflected%20subtly%2C%20soft%20natural%20light%2C%20editorial%20photography%2C%20cream%20and%20beige%20tones%2C%20trust%20and%20safety%20concept%2C%20clean%20elegant%20composition&width=800&height=560&seq=seov2-card-w3&orientation=landscape",
  "top-100-produtos-hoobuy": "https://readdy.ai/api/search-image?query=Trophy%20award%20next%20to%20collection%20of%20premium%20sneakers%2C%20sunglasses%20and%20leather%20accessories%20arranged%20on%20warm%20cream%20surface%2C%20soft%20natural%20window%20light%2C%20editorial%20photography%2C%20beige%20and%20sand%20tones%2C%20best%20products%20ranking%20concept%2C%20clean%20organized%20composition&width=800&height=560&seq=seov2-card-w4&orientation=landscape",
  "hoobuy-vs-pandabuy": "https://readdy.ai/api/search-image?query=Two%20distinct%20groups%20of%20fashion%20products%20on%20split%20warm%20cream%20background%2C%20left%20group%20with%20modern%20sneakers%20right%20group%20with%20similar%20style%20items%2C%20soft%20natural%20light%2C%20editorial%20photography%2C%20beige%20tones%2C%20comparison%20and%20choice%20concept%2C%20balanced%20clean%20composition&width=800&height=560&seq=seov2-card-w5&orientation=landscape",
  "melhor-agente-compra": "https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20premium%20fashion%20accessories%20on%20warm%20cream%20desk%20surface%2C%20small%20globe%20and%20shipping%20label%20nearby%2C%20soft%20natural%20window%20light%2C%20editorial%20photography%2C%20beige%20and%20sand%20tones%2C%20international%20shopping%20agent%20concept%2C%20clean%20professional%20composition&width=800&height=560&seq=seov2-card-w6&orientation=landscape",
  "guia-sneakers-hoobuy": "https://readdy.ai/api/search-image?query=Three%20pairs%20of%20trendy%20sneakers%20in%20different%20styles%20arranged%20diagonally%20on%20warm%20sand%20colored%20surface%2C%20soft%20natural%20light%20from%20above%2C%20editorial%20fashion%20photography%2C%20cream%20and%20beige%20tones%2C%20sneaker%20collection%20aesthetic%2C%20clean%20modern%20composition%2C%20high%20detail%20footwear%20textures&width=800&height=560&seq=seov2-card-w7&orientation=landscape",
  "guia-streetwear-hoobuy": "https://readdy.ai/api/search-image?query=Streetwear%20fashion%20flat%20lay%20with%20oversized%20hoodie%20graphic%20t-shirt%20and%20baseball%20cap%20on%20warm%20cream%20surface%2C%20soft%20natural%20light%2C%20editorial%20photography%2C%20beige%20and%20sand%20tones%2C%20urban%20youth%20culture%20aesthetic%2C%20clean%20contemporary%20composition&width=800&height=560&seq=seov2-card-w8&orientation=landscape",
  "guia-acessorios-hoobuy": "https://readdy.ai/api/search-image?query=Luxury%20accessories%20arrangement%20with%20leather%20handbag%20designer%20belt%20and%20elegant%20perfume%20on%20warm%20sand%20colored%20surface%2C%20soft%20natural%20window%20light%2C%20editorial%20photography%2C%20cream%20and%20beige%20tones%2C%20sophisticated%20fashion%20aesthetic%2C%20clean%20elegant%20composition%2C%20high%20detail%20textures&width=800&height=560&seq=seov2-card-w9&orientation=landscape",
  "dicas-compra-segura": "https://readdy.ai/api/search-image?query=Credit%20card%20and%20security%20shield%20icon%20beside%20fashion%20accessories%20on%20warm%20cream%20surface%2C%20protective%20symbols%20in%20soft%20focus%2C%20natural%20window%20light%2C%20editorial%20photography%2C%20beige%20and%20sand%20tones%2C%20safe%20online%20shopping%20concept%2C%20clean%20reassuring%20composition&width=800&height=560&seq=seov2-card-w10&orientation=landscape"
};

const tagColors = [
  "bg-accent-100/60 text-accent-700",
  "bg-secondary-100/60 text-secondary-700",
  "bg-accent-100/60 text-accent-700",
  "bg-secondary-100/60 text-secondary-700",
  "bg-accent-100/60 text-accent-700",
  "bg-secondary-100/60 text-secondary-700",
  "bg-accent-100/60 text-accent-700",
  "bg-secondary-100/60 text-secondary-700",
  "bg-accent-100/60 text-accent-700",
  "bg-secondary-100/60 text-secondary-700"
];

export default function SeoContentSection() {
  const features = [
    {
      icon: "ri-money-dollar-circle-line",
      title: "Melhor Custo-Benefício",
      desc: "Encontre os produtos com a melhor relação preço-qualidade disponíveis nas planilhas."
    },
    {
      icon: "ri-fire-line",
      title: "Produtos Mais Comprados",
      desc: "Acesse os itens mais populares entre a comunidade de compradores internacionais."
    },
    {
      icon: "ri-star-line",
      title: "Itens com Melhor Avaliação",
      desc: "Produtos com as avaliações mais altas, testados e aprovados por compradores reais."
    },
    {
      icon: "ri-user-star-line",
      title: "Fornecedores Confiáveis",
      desc: "Trabalhamos apenas com vendedores verificados e com histórico de confiabilidade comprovado."
    }
  ];

  const steps = [
    { num: "01", title: "Escolha uma Categoria", desc: "Navegue pelas 14 categorias disponíveis e encontre o tipo de produto que procura." },
    { num: "02", title: "Abra a Planilha (Spreadsheet)", desc: "Acesse a planilha organizada com todos os produtos filtrados por categoria." },
    { num: "03", title: "Clique no Produto Desejado", desc: "Explore os itens, compare preços e avaliações, e selecione seu produto." },
    { num: "04", title: "Redirecionamento para Compra", desc: "Você é levado diretamente para a página de compra segura do produto escolhido." }
  ];

  const displayArticles = allArticles.slice(0, 9);

  return (
    <section className="relative py-28 md:py-36 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-16">
        {/* What is HoobuySpreadsheet */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-foreground-700 text-xs font-semibold uppercase tracking-wider whitespace-nowrap">
              O que é
            </span>
            <h2 className="mt-5 text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              HoobuySpreadsheet:<br />
              <span className="italic font-normal">Seu Guia de Compras</span>
            </h2>
            <p className="mt-6 text-foreground-600 leading-relaxed text-sm md:text-base max-w-lg">
              O <strong className="text-foreground-900">hoobuyspreadsheet</strong> é um sistema de organização de produtos que conecta compradores a listas filtradas com os melhores itens disponíveis no mercado internacional. Nossa plataforma reúne milhares de produtos verificados em uma única planilha de fácil acesso.
            </p>

            {/* Feature Grid */}
            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-6">
              {features.map((f, idx) => (
                <div key={idx} className="flex gap-3 items-start">
                  <div className="w-9 h-9 flex-shrink-0 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                    <i className={`${f.icon} text-base`}></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{f.title}</h4>
                    <p className="text-xs text-foreground-500 mt-0.5 leading-relaxed">{f.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* How it Works */}
          <div className="bg-background-100/80 rounded-3xl p-8 md:p-10">
            <h3 className="text-xl font-heading font-bold text-foreground-950 mb-8">
              Como Funciona
            </h3>
            <div className="space-y-6">
              {steps.map((step, idx) => (
                <div key={idx} className="flex gap-5 items-start">
                  <span className="text-4xl font-heading font-bold text-accent-400 leading-none flex-shrink-0">
                    {step.num}
                  </span>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{step.title}</h4>
                    <p className="text-xs text-foreground-500 mt-1 leading-relaxed">{step.desc}</p>
                  </div>
                </div>
              ))}
            </div>
            <Link
              to="/guia/artigo-hoobuy-spreadsheet"
              className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-accent-700 hover:text-accent-800 cursor-pointer transition-colors whitespace-nowrap"
            >
              Ler Guia Completo
              <i className="ri-arrow-right-line text-sm w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>
        </div>

        {/* Article Cards Grid */}
        <div className="mt-24">
          <h3 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight text-center md:text-left">
            Artigos e Guias
          </h3>
          <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {displayArticles.map((article, idx) => (
              <Link
                key={article.slug}
                to={`/guia/${article.slug}`}
                className="rounded-2xl border border-secondary-200 overflow-hidden bg-white cursor-pointer transition-transform hover:scale-[1.02] group"
              >
                <div className="w-full h-[220px] overflow-hidden bg-background-100">
                  <img
                    src={cardImages[article.slug] || cardImages["artigo-hoobuy-spreadsheet"]}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-6">
                  <span className={`text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap ${tagColors[idx] || tagColors[0]}`}>
                    {article.category}
                  </span>
                  <h4 className="mt-3 text-base font-heading font-bold text-foreground-950 leading-snug line-clamp-2">
                    {article.title}
                  </h4>
                  <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2">
                    {article.metaDescription}
                  </p>
                </div>
              </Link>
            ))}
          </div>

          {/* Ver Todos */}
          {allArticles.length > 9 && (
            <div className="mt-10 text-center">
              <Link
                to="/guia/artigo-hoobuy-spreadsheet"
                className="inline-flex items-center gap-2 h-12 px-7 rounded-full border-2 border-foreground-300 text-foreground-800 text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-secondary-100 transition-all"
              >
                Ver Todos os Guias
                <i className="ri-arrow-right-line text-sm w-4 h-4 flex items-center justify-center"></i>
              </Link>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}